export default __webpack_public_path__ + "static/media/legs.fa94ce55.gif";